import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _URL from "@babel/runtime-corejs3/core-js/url";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance } from 'intact-vue-next';
import { _$ } from '../../i18n';
import { UploadFileStatus } from './useUpload';
import { isEqualArray } from '../utils';
var uid = 0;
export function useFiles(isValidType, upload) {
  var instance = useInstance();
  initFiles();
  function initFiles() {
    var _instance$get = instance.get(),
      files = _instance$get.files,
      defaultFiles = _instance$get.defaultFiles;
    var _files = _sliceInstanceProperty(files).call(files, 0);
    if (defaultFiles) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn("'defaultFiles' is deprecated, use 'files' instead for reactive updating.");
      }
      defaultFiles.forEach(function (file) {
        _files.push(normalizeFile(file));
      });
      instance.set('files', _files);
    }
  }
  instance.on("$receive:files", function (files, oldFiles) {
    if (!files || isEqualArray(files, oldFiles)) return;
    instance.set('files', _mapInstanceProperty(files).call(files, normalizeFile));
  });
  function addFiles(_x) {
    return _addFiles.apply(this, arguments);
  }
  function _addFiles() {
    _addFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fileList) {
      var _context;
      var files, newFiles, _instance$get2, maxSize, limit, autoUpload, accept, error, status, i, file, _error, _error2, obj;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            files = _sliceInstanceProperty(_context = instance.get('files')).call(_context, 0);
            newFiles = _Array$from(fileList);
            _instance$get2 = instance.get(), maxSize = _instance$get2.maxSize, limit = _instance$get2.limit, autoUpload = _instance$get2.autoUpload, accept = _instance$get2.accept;
            if (!(limit && files.length + newFiles.length > limit)) {
              _context2.next = 6;
              break;
            }
            error = new Error(_$('超出文件数量最大限制：{limit}', {
              limit: limit
            }));
            return _context2.abrupt("return", instance.trigger('error', error, newFiles, files));
          case 6:
            status = autoUpload ? UploadFileStatus.Ready : UploadFileStatus.NotReady;
            i = 0;
          case 8:
            if (!(i < newFiles.length)) {
              _context2.next = 30;
              break;
            }
            file = newFiles[i];
            if (!(maxSize && file.size > maxSize * 1024)) {
              _context2.next = 14;
              break;
            }
            _error = new Error(_$('"{name}" 超出文件最大限制：{maxSize}kb', {
              name: file.name,
              maxSize: maxSize
            }));
            instance.trigger('error', _error, file, files);
            return _context2.abrupt("continue", 27);
          case 14:
            if (!(accept && file.type && !isValidType(file.type, file.name))) {
              _context2.next = 18;
              break;
            }
            _error2 = new Error(_$('"{name}" 文件类型不合法', {
              name: file.name
            }));
            instance.trigger('error', _error2, file, files);
            return _context2.abrupt("continue", 27);
          case 18:
            obj = {
              status: status,
              name: file.name,
              type: file.type,
              size: file.size,
              percent: 0,
              uid: uid++,
              raw: file
            };
            if (_URL && _URL.createObjectURL) {
              obj.url = _URL.createObjectURL(file);
            }
            _context2.t0 = !autoUpload;
            if (_context2.t0) {
              _context2.next = 25;
              break;
            }
            _context2.next = 24;
            return upload(obj);
          case 24:
            _context2.t0 = _context2.sent;
          case 25:
            if (!_context2.t0) {
              _context2.next = 27;
              break;
            }
            files.push(obj);
          case 27:
            i++;
            _context2.next = 8;
            break;
          case 30:
            instance.set('files', files);
          case 31:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    }));
    return _addFiles.apply(this, arguments);
  }
  function removeFile(_x2, _x3) {
    return _removeFile.apply(this, arguments);
  }
  function _removeFile() {
    _removeFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, index) {
      var _context3;
      var beforeRemove, files, shouldRemove;
      return _regeneratorRuntime.wrap(function _callee2$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            beforeRemove = instance.get('beforeRemove');
            files = _sliceInstanceProperty(_context3 = instance.get('files')).call(_context3, 0);
            shouldRemove = true;
            if (!beforeRemove) {
              _context4.next = 7;
              break;
            }
            _context4.next = 6;
            return beforeRemove(file, files);
          case 6:
            shouldRemove = _context4.sent;
          case 7:
            if (shouldRemove) {
              _spliceInstanceProperty(files).call(files, index, 1);
              if (file.status === UploadFileStatus.Uploading) {
                file.request.abort();
              }
              instance.set('files', files);
            }
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee2);
    }));
    return _removeFile.apply(this, arguments);
  }
  return {
    addFiles: addFiles,
    removeFile: removeFile
  };
}
function normalizeFile(file) {
  return _extends({
    status: UploadFileStatus.Done,
    percent: 100,
    uid: uid++,
    raw: file
  }, file);
}